module.exports = __webpack_public_path__ + "static/media/dualJuniorBlock.b0f680f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/dualJuniorBlock.png
// module id = 599
// module chunks = 0